import React, { Component } from "react";
import { connect } from "react-redux";

import './notification.css'
import { Selected_Index } from "../../../../../constants/external-constants";
import { ListTabButton } from "../../../list-tab/list-tab-button.component";
import { TablePagination } from "../../../details-table/table-pagination.component";
import ButtonIcon from "../../../../button";
import { TRANSLATIONS } from "../../../../../utils/constant.utils";
import { NoSubscription } from "../../../../external/dashboard/no-subscription/no-subscription.component"; 

class UploadNotification extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Charge Mapping Error",
                    "hidden": false,
                    "disable": false
                }
            ]
        }
    }

    componentDidMount() {
        this.props.paginationActionTab1(0);
    }

    FilterIndex = (tabIndex) => {
        this.renderTabContent(tabIndex)
        if(this.props.enableUploadButton) {
            this.props.enableUploadButton(tabIndex)
        }
    }

    renderTabContent = (index) => {
        this.setState({ selectedIndex: index });

        if (index == 0) {
            this.props.paginationActionTab1(0);
        }
        else {
            this.props.paginationActionTab2(0);
        }
    }

    activeListTab = (listTab) => {
        const { disputeDetailsId } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && disputeDetailsId > 0) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    onClickExtract2 = (e) => {
        const confirmationMessage = this.toLocaleLanguage('export_alert_message');
        if (window.confirm(confirmationMessage)) {
            this.props.clickExtract2();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];

        return TRANSLATIONS[locale][key];
    }

    loading = () => {
        return (
            <div className="notification-view-error-loading">
                <NoSubscription />
            </div>
        );
    }

    render() {
        const { errorDetails, paginationActionTab1, paginationActionTab2, columnClick2 } = this.props;
        const {listTab, selectedIndex} = this.state;
        return(
            <div className="upload-notification-container">
                <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} />
                     { !errorDetails.isLoading ? 
                            this.state.selectedIndex === Selected_Index.i_Zero ?
                            <div className="notification-upload-table">
                            <TablePagination
                                key="table-pagination-key"
                                columns={errorDetails.upload.Headers ?? []}
                                pageList={errorDetails.upload.Data ?? []}
                                paginationAction={paginationActionTab1}
                                pages={errorDetails.upload.Pagination}
                                onColumnSearch={() => { }}
                                onColumnSearchChange={() => { }}
                                isColSearchShow={false}
                                resizePage={() => { }}
                                totalPage={errorDetails.upload.Pagination.TotalEntries}
                                isNotSortable={true}
                                isLoading={false}
                                paginationHidden={true}
                            />
                            </div>                  
                        :
                        <div className="charge-mapping-error-details-container">
                            <div className="button-container">
                                <ButtonIcon 
                                    isDisable={errorDetails.chargeMapping.Data.Items.length == 0} 
                                    onClick={this.onClickExtract2} 
                                    iconLeft="cloud-arrow-down" 
                                    iconSize="17px" 
                                    customClassName="header-option-list header-filter-button" 
                                    labelName="Extract List" 
                                />
                            </div>
                            <div className="notification-upload-table">
                            <TablePagination
                                key="table-pagination-key"
                                columns={errorDetails.chargeMapping.Headers ?? []}
                                pageList={errorDetails.chargeMapping.Data ?? []}
                                pages={errorDetails.chargeMapping.Pagination}                     
                                paginationAction={paginationActionTab2}
                                onColumnClick={columnClick2}
                                onColumnSearch={() => { }}
                                onColumnSearchChange={()=>{}}
                                isColSearchShow={false}
                                resizePage={() => { }}
                                totalPage={errorDetails.chargeMapping.Pagination.TotalEntries}
                                isLoading={false}    
                                hidePageSizeSelection={true}   
                            />
                            </div>
                        </div>
                        : this.loading()
                    }
            </div>
        )
    }
}

export default connect(
    state => {
        const { translation } = state;

        return {
            translation
        };
    }
)(UploadNotification)

